import { render, staticRenderFns } from "./IconPicker.vue?vue&type=template&id=12f84e67&scoped=true&"
import script from "./IconPicker.vue?vue&type=script&lang=js&"
export * from "./IconPicker.vue?vue&type=script&lang=js&"
import style0 from "./IconPicker.vue?vue&type=style&index=0&id=12f84e67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f84e67",
  null
  
)

export default component.exports